import RelaxIntro from "@/assets/audios/Relaxation-Excercise-intro-sentence1.m4a";
import RelaxationExerciseFlow from "@/components/Exercises/Relaxation/RelaxationExerciseFlow";
import { Button } from "@/components/ui/button";
import { ExerciseLayout } from "@/components/ui/exercise-layout";
import MediaPlayer from "@/components/ui/media-player";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { FormattedMessage } from "react-intl";


export const Route = createFileRoute("/(content)/adults/exercises/(shared)/relaxation/")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>) => ({
    referrer: search?.referrer as string | undefined,
    referrerGroup: search?.referrerGroup as string | undefined,
  }),
  head: () => ({
    meta: [
      {
        title: "An Exercise Through Muscle Relaxation - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "stress.exercises.relaxationExercise",
    navbar: {
      showTitle: true,
    },
  }),
});

function RouteComponent() {
  const [showOverlay, setShowOverlay] = useState(false);
  const [isPausedAudio, setIsPausedAudio] = useState(false);

  const startExercise = () => {
    setIsPausedAudio(true);
    setShowOverlay(true);
  };

  const closeOverlay = () => {
    setShowOverlay(false);
    setIsPausedAudio(false);
  };

  return (
    <ExerciseLayout
      contentClassName="py-7.5 space-y-18"
      actions={
        <Button className="w-full" onClick={startExercise}>
          <FormattedMessage id="treeOfLife.intro.start.button" />
        </Button>
      }
    >
      <p className="text-small text-dark">
        <FormattedMessage id="relaxationExercise.intro" />
      </p>
      <MediaPlayer src={RelaxIntro} isPaused={isPausedAudio} />
      <RelaxationExerciseFlow onComplete={closeOverlay} onExit={closeOverlay} isShow={showOverlay} />
    </ExerciseLayout>
  );
}
